
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gbchRxruKAlF7yVGOkJ_45PVI3MTiBWEa2Fe97OdMmar7wMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexEqsQ3V0IVxOKzKnqpRSHZoMumqjzYaf_WyeRHjZn_45ucMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search9WAQ_45cyqB1sNHpBwr7rUa20nnAHjSj2sE7wIxoIP_EcMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index0ljrLlzs1w2G_45nb1DK_45UWr_oONb29AOicqfdbi_kQu0Meta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93W0SNI4dvuAYAxhEVOPPsBewzbScQvffVSdbDX8xA31cMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexLh39A4Wt9FU_TFpmsHpwnua7KwoBe5k8ihl0b7spgIsMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93KuO2IYNXfyIlDBdwL2FVMfR37UJH93s_45AwjolZErpYYMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexzPe18gMGaI47tNGf7CJ7mti5nMCvlLthAi2ojwi_45UBAMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93RYzb_45COuwmdJF61czjRhr3RCJnpy3pXQ60ysRWdBsQoMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpCUhGhHerm2qNBquGGDObHzcK4IffnmpE2wEwj1fnZUMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexgEVfNvVZzTNV_IOxBIv1hKSpkfA5JAgABxOFHocA0ukMeta } from "/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexLh39A4Wt9FU_TFpmsHpwnua7KwoBe5k8ihl0b7spgIsMeta || {},
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexzPe18gMGaI47tNGf7CJ7mti5nMCvlLthAi2ojwi_45UBAMeta || {},
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpCUhGhHerm2qNBquGGDObHzcK4IffnmpE2wEwj1fnZUMeta || {},
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexgEVfNvVZzTNV_IOxBIv1hKSpkfA5JAgABxOFHocA0ukMeta || {},
    component: () => import("/codebuild/output/src151211759/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]